﻿import React from 'react';
import { str_isEmpty } from '@Util/Utils';

import { Customer_Name_With_Color_Props } from '@Util/Types';

export default function Customer_Name_With_Color(props: Customer_Name_With_Color_Props): JSX.Element {
    return (
        <div className="Table_Customer_With_Color">
            {
                !str_isEmpty(props.color) &&
                <span
                    className="Customer_Color"
                    style={{ backgroundColor: `rgb(${props.color})` }}
                    aria-label="hidden"
                ></span>
            }
            {
                !str_isEmpty(props.name) &&
                <span className="Table_Data_Customer_Name">{props.name}</span>
            }
        </div>
    )
}